// components/Templates/PageHeader/PageHeader.js
import React from 'react';
import PropTypes from 'prop-types';
import { RawHtml } from '../../Utilities';

const PageHeader = ({ title = '', intro = '', description = '' }) => {
  return (
    <div className="page__header">
      {title && (
        <div className="text-page-title">{title}</div>
      )}
      {intro && (
        <div className="text-page-subtitle">
          <RawHtml html={intro} />
        </div>
      )}
      {description && (
        <div className="text-body">
          <RawHtml html={description} />
        </div>
      )}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  intro: PropTypes.string,
  description: PropTypes.string,
};

export default PageHeader;